import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule, NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './header/header.component';
import {DataService} from './dataService.service';
import {HttpClientModule} from '@angular/common/http';
import { AppConfigService } from './appConfig.Service';
import { SlidesComponent } from './slides/slides.component';
import { ContactDetailsComponent } from './contact-details/contact-details.component';
import { ProductsBannerComponent } from './products-banner/products-banner.component';

export function init_app(appConfigService: AppConfigService) {
  return () => appConfigService;
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SlidesComponent,
    ContactDetailsComponent,
    ProductsBannerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,  NgbModule, HttpClientModule,
    
  ],
  exports:[
    SlidesComponent
  ],
  providers: [DataService,
    AppConfigService,
    {provide:APP_INITIALIZER, useFactory:init_app, deps: [AppConfigService], multi: true}
  
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
